import BackgroundQrScanner from './BackgroundQrScanner'
export * from './BackgroundQrScanner'

export default BackgroundQrScanner
